export class ShowcasePerformedBy {
  static customer = 0;
  static self = 1;
}
